import React from 'react';
import * as styles from './styles.css';
import { Body1, Body2 } from '@cian/ui-kit';
import { Mapper } from '../../../../utils';

export interface IFactRowProps {
  title: string | null;
  subtitle?: string | null;
  imagePath: string | null;
}

export function FactRow({ title, subtitle, imagePath }: IFactRowProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon-wrapper']}>
        <Mapper icon={imagePath} />
      </div>
      <div className={styles['text-wrapper']}>
        <Body1>{title}</Body1>
        <Body2 color="text-secondary-default">{subtitle}</Body2>
      </div>
    </div>
  );
}
